import apiUrl from "../../../../utils/settings";

export const canOnboardUrl = () => apiUrl + "/onboarding/can-onboard";

export const digiLockerInitiateUrl = () => apiUrl + "/digilocker/v2/initiate";

export const digiLockerFetchUrl = (sessionId) =>
  apiUrl +
  `/digilocker/v2/fetch/${sessionId}?doc_type=AADHAAR&require_internal_address_mapping=true`;

export const throughExistingUserUrl = () =>
  apiUrl + "/onboarding/through-existing-user";
